import type { DiagnosticApp } from '@shared/prospect-diagnostic';
import { SideDrawer } from '@/components/ui/SideDrawer';

/** The example: a result line since prompt v5, one sentence before. */
const AppExample = ({ app }: { app: DiagnosticApp }) => {
  if (!app.exampleTitle && !app.example) return null;
  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-[13px] font-semibold uppercase tracking-wide text-domino-inkSoft">Exemple</h3>
      <p className="rounded-xl bg-white px-4 py-3 text-[15px]">
        {app.exampleTitle ? (
          <>
            <span className="font-semibold">{app.exampleTitle}</span>
            {app.exampleFact && <span className="text-domino-inkSoft"> — {app.exampleFact}</span>}
            {app.exampleDetail && <span className="block pt-1">{app.exampleDetail}</span>}
          </>
        ) : app.example}
      </p>
    </section>
  );
};

/** One app of the diagnostic in full: what it reads and gives, an example, how it would go about it. */
export const DiagnosticAppDrawer = ({ app, role, onClose }: { app: DiagnosticApp; role: string; onClose: () => void }) => (
  <SideDrawer label={app.name} title={app.name} onClose={onClose}>
    <div className="flex flex-col gap-7 px-5 py-6 sm:px-8">
      <dl className="grid grid-cols-[auto_1fr] gap-x-5 gap-y-2 text-[15px]">
        <dt className="text-domino-inkSoft">Pour</dt>
        <dd>{role}</dd>
        <dt className="text-domino-inkSoft">Lit</dt>
        <dd>{app.reads}</dd>
        <dt className="text-domino-inkSoft">Donne</dt>
        <dd>{app.produces}</dd>
      </dl>
      <AppExample app={app} />
      {(app.steps ?? []).length > 0 && (
        <section className="flex flex-col gap-3">
          <h3 className="text-[13px] font-semibold uppercase tracking-wide text-domino-inkSoft">Comment elle s’y prendrait</h3>
          <ol className="flex flex-col gap-2 border-l-2 border-domino-sand pl-4">
            {(app.steps ?? []).map((step, index) => (
              <li key={`${index}-${step}`} className="flex gap-3 text-[15px]">
                <span className="w-4 flex-none font-semibold text-domino-inkSoft">{index + 1}</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </section>
      )}
    </div>
  </SideDrawer>
);
